export type EditorApp = 'website' | 'canvas';

export interface EditorSession {
  editor: EditorApp;
  sessionId: string;
  title: string;
  artifactId?: string | null;
  visitedAt: number;
}

export const EDITOR_SESSIONS_CHANGED = 'attune:editor-sessions-changed';
export const EDITOR_SESSION_LIMIT = 30;

export function parseEditorSessions(raw: string | null): EditorSession[] {
  try {
    const values: unknown = JSON.parse(raw || '[]');
    if (!Array.isArray(values)) return [];
    return values
      .filter((value): value is EditorSession =>
        Boolean(
          value &&
            (value.editor === 'website' || value.editor === 'canvas') &&
            typeof value.sessionId === 'string' &&
            value.sessionId.length > 0 &&
            typeof value.title === 'string' &&
            typeof value.visitedAt === 'number' &&
            Number.isFinite(value.visitedAt) &&
            (value.artifactId == null || typeof value.artifactId === 'string')
        )
      )
      .sort((a, b) => b.visitedAt - a.visitedAt)
      .slice(0, EDITOR_SESSION_LIMIT);
  } catch {
    return [];
  }
}

export function mergeEditorSession(sessions: EditorSession[], entry: EditorSession) {
  const previous = sessions.find(
    item => item.editor === entry.editor && item.sessionId === entry.sessionId
  );
  const updated = { ...entry, artifactId: entry.artifactId === undefined ? previous?.artifactId : entry.artifactId };
  return [
    updated,
    ...sessions.filter(item => item.editor !== entry.editor || item.sessionId !== entry.sessionId),
  ].slice(0, EDITOR_SESSION_LIMIT);
}

export function editorSessionHref(editor: EditorApp, session?: EditorSession) {
  const query = new URLSearchParams({ editor });
  if (session) {
    query.set('session', session.sessionId);
    if (session.artifactId)
      query.set(editor === 'canvas' ? 'canvas' : 'preview', session.artifactId);
  } else {
    query.set('new_chat', 'true');
  }
  return `/app/workspace?${query}`;
}
